<template>
  <v-dialog v-model="isProjectAttributesDialogOpen" max-width="650px" persistent>
    <v-card class="pa-sm-6 pa-2">
      <v-card-title class="justify-center text-h5">Edit Project Information</v-card-title>

      <v-card-text class="mt-4">
        <v-form ref="projectAttrForm">
          <v-row dense>
            <!-- Departments -->
            <v-col cols="12">
              <v-autocomplete
                v-model="projectDataLocal.departments"
                :items="deptOptions"
                :loading="deptLoading"
                item-text="label"
                label="Departments Involved"
                multiple outlined dense small-chips deletable-chips
                :rules="[validators.requiredArray]"
              ></v-autocomplete>
            </v-col>

            <!-- Insights (Filtered by Dept ID 5) -->
            <v-col cols="12" v-for="team in teamConfigs" :key="team.key">
              <v-autocomplete
                v-model="projectDataLocal[team.key]"
                :items="filterInsights"
                :loading="userLoading"
                :label="team.label"
                multiple outlined dense small-chips deletable-chips
                item-text="name" item-value="id"
              >
                <template #item="{ item }">
                  <v-avatar :color="stringToHslColor(item.name)" size="24" class="me-2">
                    <span class="white--text text-xs">{{ avatarText(item.name) }}</span>
                  </v-avatar>
                  {{ item.name }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="projectDataLocal.key_comments" label="Comments" outlined rows="3"></v-textarea>
            </v-col>

            <v-col cols="12" class="d-flex justify-center pt-4">
              <v-btn color="primary" class="me-3" :loading="updateLoading" @click="onSubmit">Update</v-btn>
              <v-btn outlined color="secondary" @click="$emit('update:is-project-attributes-dialog-open', false)">Cancel</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import useProject from '../../useProject'
import useProjectView from '../useProjectView'
import { stringToHslColor } from '@core/utils'
import { avatarText } from '@core/utils/filter'
import { requiredArray } from '@core/utils/validation'

export default {
  props: {
    isProjectAttributesDialogOpen: Boolean,
    projectData: Object,
  },
  setup(props, { emit }) {
    const projectAttrForm = ref(null)
    const projectDataLocal = ref({})
    const { deptLoading, deptOptions, userLoading, userOptions, fetchDepartments, fetchUsers } = useProject()
    const { updateLoading } = useProjectView()

    const teamConfigs = [
      { key: 'insights', label: 'Insights Team Members' },
      { key: 'experts', label: 'Experts' }
    ]

    const filterInsights = computed(() => userOptions.value.filter(u => u.department === 5))

    const onSubmit = async () => {
      if (projectAttrForm.value.validate()) {
        updateLoading.value = true
        emit('update-project', JSON.parse(JSON.stringify(projectDataLocal.value)))
      }
    }

    watch(
      () => props.projectData, 
      () => {
        updateLoading.value = false
        emit('update:is-project-attributes-dialog-open', false)
      },
    )

    watch(() => props.isProjectAttributesDialogOpen, (val) => {
      if (val) {
        if (!userOptions.value.length) fetchUsers()
        if (!deptOptions.value.length) fetchDepartments()
        
        projectDataLocal.value = {
          id: props.projectData.id,
          departments: props.projectData.departments.map(i => i.id),
          insights: props.projectData.insights.map(i => i.id),
          experts: props.projectData.experts.map(i => i.id),
          key_comments: props.projectData.key_comments,
        }
      }
    })

    return {
      projectDataLocal, deptLoading, deptOptions, userLoading, filterInsights,
      updateLoading, projectAttrForm, teamConfigs, onSubmit,
      avatarText, stringToHslColor, validators: { requiredArray }
    }
  }
}
</script>